package com.iregained.site.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.iregained.site.components.cms.CmsSection
import com.iregained.site.components.cms.DynamicSectionRenderer
import com.iregained.site.components.layouts.PageLayout
import com.iregained.site.components.widgets.BackToTopButton
import com.varabyte.kobweb.compose.css.dvh
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import kotlinx.browser.document
import kotlinx.coroutines.delay
import kotlin.time.Duration.Companion.milliseconds

@Page("/about")
@Composable
fun AboutPage() {
    val ctx = rememberPageContext()

    // FOOLPROOF SCROLL ANCHOR: Combats Layout Shift from loading images
//    LaunchedEffect(ctx.route.fragment) {
//        val fragment = ctx.route.fragment
//        if (!fragment.isNullOrBlank()) {
//            // Pulse the smooth scroll command as network images expand the DOM above
//            for (i in 1..4) {
//                delay(100.milliseconds) // Adjusts the view at 350ms, 700ms, 1050ms, and 1400ms
//                document.getElementById(fragment)?.asDynamic().scrollIntoView(
//                    js("{ behavior: 'smooth', block: 'start' }")
//                )
//            }
//        }
//    }

    val pageSections: List<CmsSection> = listOf(
        CmsSection.AboutHeroSection(),
        CmsSection.AboutOriginSection(),
        CmsSection.AboutFounderLetterSection(),
        CmsSection.AboutValuesSection(),
        CmsSection.AboutLeadershipSection(),
        CmsSection.AboutTrustSection(),
        CmsSection.AboutCareersSection(),
        CmsSection.AboutCtaSection(),
    )

    PageLayout {
        Column(
            modifier = Modifier.fillMaxWidth(), horizontalAlignment = Alignment.CenterHorizontally
        ) {
            // DYNAMIC RENDERER LOOP
            pageSections.forEach { section ->
                DynamicSectionRenderer(section)
            }
        }
        BackToTopButton()
    }
}